import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../../../_services/snackbar/snackbar.service';

@Component({
    selector: 'lokos-reference-dialog',
    templateUrl: './reference-dialog.component.html',
    styleUrl: './reference-dialog.component.scss',
    standalone: false,
})
export class ReferenceDialogComponent implements OnInit {
    message = '';
    confirmationButtonLabel = '';
    cancelButtonLabel = '';
    title = 'Alert!!';
    referenceNumber!: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private matDialogRef: MatDialogRef<ReferenceDialogComponent>,
        private _snack: SnackbarService
    ) {}

    ngOnInit(): void {
        this.message = this.data.message;
        this.confirmationButtonLabel = this.data.confirmationButtonLabel;
        this.cancelButtonLabel = this.data.cancelButtonLabel;
        this.title = this.data.title;
        this.referenceNumber = this.data.referenceNumber;
    }

    onCancel(): void {
        this.matDialogRef.close(false);
    }

    onConfirm(): void {
        this.matDialogRef.close(true);
    }

    copyToClipboard() {
        navigator.clipboard
            .writeText(this.referenceNumber)
            .then(() => {
                this._snack.successSnackbar('copied');
            })
            .catch(() => {
                this._snack.errorSnackbar('couldNotCopyText');
            });
    }
}
